<template>
    <main-content v-if="$can('manage-collective-gateways', 'ipg-gateway')" with_go_back_bar>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import columns from "./datatable/active_gateways_columns";
import actionsColumn from "./datatable/active-gateways-actions-column";
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'

export default {
    components: {
        'main-content': mainContent,
    },
    computed: {
        datatableProps() {
            return {
                id: "gateway_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('collective/active-gates'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
}
</script>

<style>

</style>